import React from "react";

import TextInput from "veneer/TextInput";

interface NumberFieldProps {
  error?: boolean;
  field: {
    displayName?: string;
    name: string;
    value?: number | string | null;
  };
  handleChange: (value: number | null) => void;
  helperText?: string | null;
  isRequired: boolean;
  readOnly: boolean;
}

const NumberField = ({
  error = false,
  field,
  handleChange,
  helperText,
  isRequired,
  readOnly,
}: NumberFieldProps) => {
  const fieldValue = Number.isNaN(parseFloat(String(field.value)))
    ? ""
    : String(field.value);

  const onChange = (value: string | null): void => {
    const parsedValue = value === null ? Number.NaN : parseFloat(value);
    handleChange(Number.isNaN(parsedValue) ? null : parsedValue);
  };

  return (
    <TextInput
      dataTestId={`${field.name}.Input`}
      disabled={readOnly}
      error={error}
      fullWidth
      helperText={helperText ?? undefined}
      label={field.displayName}
      onChange={onChange}
      required={isRequired}
      type="text"
      value={fieldValue}
    />
  );
};

export { NumberField };
